import { uiAnimate } from '../animate';
import { $el } from '../elements';
import { UIView } from '../view';

class UIToast extends UIView {
    private _dismissed?: boolean;

    constructor(text: string) {
        super('div', 'ui-toast');

        this.ui_add($el.DIV('r-container', text));
    }

    open(duration: number) {
        document.body.appendChild(this.root);
        setTimeout(() => { this.dismiss(false) }, duration);
        uiAnimate([{ what: this, animation: 'toast-in', duration: 0.25, easing: 'ease-in-out' }]);
    }

    dismiss(quick: boolean) {
        if(this._dismissed) return;
        this._dismissed = true;
        uiAnimate([{ what: this, animation: 'toast-out', duration: quick ? 0.1 : 0.4, easing: 'ease-in-out' }], () => { this.root.remove(); });

    }
}

let current: UIToast | undefined;

export function uiToast(text: string, duration: number = 5000) {
    if(current)
        current.dismiss(true);

    current = new UIToast(text);
    current.open(duration);
}

export function uiToastAndRethrow(text: string, duration: number = 5000): never {
    uiToast(text, duration);
    throw text;
}
